// Ronsoco wishlist. Saved in this browser only (localStorage), so it needs no app.
// Hearts: [data-wishlist-toggle] on product pages and cards, [data-wishlist-open] in the header.
// The panel (snippets/ronsoco-wishlist.liquid) draws each item with sections/ronsoco-wishlist-item.liquid.
(() => {
  // Not window.RonsocoWishlist: the panel's id makes the browser define that name for the element
  if (window.ronsocoWishlist) return;

  const KEY = 'ronsoco-wishlist';
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  let memory = []; // used when the browser blocks storage (private mode)

  const read = () => {
    try {
      const items = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(items) ? items : [];
    } catch (e) {
      return memory;
    }
  };

  const write = (items) => {
    memory = items;
    try {
      localStorage.setItem(KEY, JSON.stringify(items));
    } catch (e) {}
    syncHearts();
  };

  const has = (handle) => read().some((item) => item.handle === handle);
  const add = (handle, variant) =>
    write([{ handle, variant, added: Date.now() }, ...read().filter((item) => item.handle !== handle)]);
  const remove = (handle) => write(read().filter((item) => item.handle !== handle));

  const dialog = () => document.getElementById('RonsocoWishlist');

  function syncHearts() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach((button) => {
      const saved = has(button.dataset.handle);
      button.setAttribute('aria-pressed', saved);
      button.setAttribute('aria-label', saved ? 'Remove from wishlist' : 'Save to wishlist');
    });
  }

  function showState(count) {
    const panel = dialog();
    if (!panel) return;
    panel.querySelector('[data-wishlist-head]').hidden = count === 0;
    panel.querySelector('[data-wishlist-note]').hidden = count === 0;
    panel.querySelector('[data-wishlist-empty]').hidden = count !== 0;
    panel.querySelector('[data-wishlist-count]').textContent = count === 1 ? '1 item' : `${count} items`;
  }

  async function fetchItem(item) {
    const variant = item.variant ? `variant=${encodeURIComponent(item.variant)}&` : '';
    try {
      const response = await fetch(`${root}products/${encodeURIComponent(item.handle)}?${variant}section_id=ronsoco-wishlist-item`);
      if (response.status === 404) return { item, gone: true };
      if (!response.ok) return { item, html: '' };
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const element = doc.querySelector('.rwl__item');
      return { item, html: element ? element.outerHTML : '', gone: !element };
    } catch (e) {
      return { item, html: '' };
    }
  }

  async function render() {
    const panel = dialog();
    if (!panel) return;
    const list = panel.querySelector('[data-wishlist-list]');
    const items = read();
    showState(items.length);
    if (!items.length) {
      list.innerHTML = '';
      return;
    }
    list.setAttribute('aria-busy', 'true');
    const results = await Promise.all(items.map(fetchItem));
    // Drop products that no longer exist or are no longer for sale online
    const gone = results.filter((result) => result.gone).map((result) => result.item.handle);
    if (gone.length) write(read().filter((item) => !gone.includes(item.handle)));
    list.innerHTML = results
      .filter((result) => result.html)
      .map((result) => result.html)
      .join('');
    list.removeAttribute('aria-busy');
    showState(list.querySelectorAll('.rwl__item').length);
  }

  function open() {
    const panel = dialog();
    if (!panel) return;
    if (!panel.open) panel.showModal();
    document.body.classList.add('overflow-hidden');
    render();
  }

  function close() {
    const panel = dialog();
    if (panel && panel.open) panel.close();
  }

  function openHeaderSearch() {
    const search = [...document.querySelectorAll('.header__search')].find((el) => el.offsetParent !== null);
    if (search) search.querySelector('summary').click();
  }

  async function refreshCartIcon() {
    try {
      const response = await fetch(`${root}?sections=cart-icon-bubble`);
      const sections = await response.json();
      const icon = document.getElementById('cart-icon-bubble');
      if (!icon || !sections['cart-icon-bubble']) return;
      const doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      const inner = doc.querySelector('.shopify-section');
      if (inner) icon.innerHTML = inner.innerHTML;
    } catch (e) {}
  }

  // Same request as the theme's product form, so the cart drawer opens with the item in it
  async function addToCart(button) {
    const itemEl = button.closest('.rwl__item');
    const error = itemEl.querySelector('.rwl__error');
    const cart = document.querySelector('cart-drawer');
    const formData = new FormData();
    formData.append('id', itemEl.dataset.variant);
    formData.append('quantity', 1);
    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map((section) => section.id));
      formData.append('sections_url', window.location.pathname);
    }
    const config =
      typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST', headers: { Accept: 'application/javascript' } };
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];
    config.body = formData;

    button.setAttribute('aria-disabled', 'true');
    error.hidden = true;
    try {
      const response = await fetch((window.routes && window.routes.cart_add_url) || `${root}cart/add`, config);
      const data = await response.json();
      if (data.status) {
        error.textContent = data.description || data.message || 'Could not add this item.';
        error.hidden = false;
        return;
      }
      if (!cart) {
        window.location = (window.routes && window.routes.cart_url) || `${root}cart`;
        return;
      }
      close();
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'wishlist', productVariantId: itemEl.dataset.variant, cartData: data });
      }
      cart.renderContents(data);
      cart.classList.remove('is-empty');
      refreshCartIcon();
    } catch (e) {
      error.textContent = 'Could not add this item.';
      error.hidden = false;
    } finally {
      button.removeAttribute('aria-disabled');
    }
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-wishlist-toggle]');
    if (toggle) {
      const handle = toggle.dataset.handle;
      if (has(handle)) {
        remove(handle);
      } else {
        const scope = toggle.closest('ronsoco-product') || document;
        const idInput = toggle.dataset.variant ? null : scope.querySelector('form input[name="id"]');
        add(handle, toggle.dataset.variant || (idInput ? idInput.value : null));
        open();
      }
      return;
    }

    if (event.target.closest('[data-wishlist-open]')) {
      open();
      return;
    }

    const panel = dialog();
    if (!panel || !panel.contains(event.target)) return;

    if (event.target === panel || event.target.closest('[data-wishlist-close]')) {
      close(); // the backdrop counts as a click on the dialog itself
    } else if (event.target.closest('[data-wishlist-search]')) {
      close();
      openHeaderSearch();
    } else if (event.target.closest('[data-wishlist-cart]')) {
      const cart = document.querySelector('cart-drawer');
      if (cart && typeof cart.open === 'function') {
        event.preventDefault();
        close();
        cart.open();
      }
    } else if (event.target.closest('[data-wishlist-remove]')) {
      const itemEl = event.target.closest('.rwl__item');
      remove(itemEl.dataset.handle);
      itemEl.remove();
      showState(panel.querySelectorAll('.rwl__item').length);
    } else if (event.target.closest('[data-wishlist-add]')) {
      addToCart(event.target.closest('[data-wishlist-add]'));
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    syncHearts();
    const panel = dialog();
    if (panel) panel.addEventListener('close', () => document.body.classList.remove('overflow-hidden'));
  });

  // Keep hearts right when the wishlist changes in another tab
  window.addEventListener('storage', (event) => {
    if (event.key === KEY) syncHearts();
  });

  window.ronsocoWishlist = { open, close, add, remove, has, items: read, sync: syncHearts };
})();
